<template>
    <Breadcrumbs main="FAQ" title="FAQ" />
    <div class="container-fluid">
        <div class="faq-wrap">
            <div class="row">
                <faqWidgets />
                <faqAccordion />
                <featuredTutorial />
                <faqArticles />
            </div>
        </div>
    </div>
</template>
<script lang="ts" setup>
import { defineAsyncComponent } from 'vue';
const faqWidgets = defineAsyncComponent(() => import("@/components/theme/faq/faqWidgets.vue"))
const faqAccordion = defineAsyncComponent(() => import("@/components/theme/faq/faqAccordion.vue"))
const featuredTutorial = defineAsyncComponent(() => import("@/components/theme/faq/featuredTutorial.vue"))
const faqArticles = defineAsyncComponent(() => import("@/components/theme/faq/faqArticles.vue"))
</script>